import Vue from 'vue';
import { sessionKeys } from '@/data/constants';

export default Vue.extend({
  data() {
    return {
      currentStep: {},
      swiperOption: {
        lazy: true,
        pagination: {
          el: '.swiper-pagination-ugc-introvideos',
        },
        navigation: {
          nextEl: '.icon-arrow-right-indicator-open',
          prevEl: '.icon-arrow-left-indicator-open',
        },
      },
      isLastIndex: false,
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    }
  },
  methods: {
    onRightClick() {
      if (this.isLastIndex) {
        this.goNext();
      }
    },
    onVideoEnded() {
      const activeIndex = (this as any).$refs.introVideosCustomizerSwiper.$swiper.activeIndex;

      if (activeIndex === (this as any).steps.length - 1) {
        this.goNext();
      } else {
        (this as any).$refs.introVideosCustomizerSwiper.$swiper.slideNext();
      }
    },
    onSwiperSlideChange() {
      this.isLastIndex = ((window as any).activeIndex === ((this as any).steps.length - 1));
      const activeIndex = (this as any).$refs.introVideosCustomizerSwiper.$swiper.activeIndex;

      this.currentStep = (this as any).steps[activeIndex];
      (this as any).$refs['step' + activeIndex][0].src =
        `${ (this.currentStep as any).videoUrl }`;
      (this as any).$refs['step' + activeIndex][0].onload = () => {
        (this as any).$refs['step' + activeIndex][0].play();
      };

      (this as any).onSlideChange(this.currentStep);
    },
    onTouchEnd() {
      this.verifyLastVideo();
    },
    goNext() {
      (this as any).onNext();
    },
    verifyLastVideo() {
      const activeIndex = (this as any).$refs.introVideosCustomizerSwiper.$swiper.activeIndex;

      if (this.isLastIndex) {
        this.goNext();
      }

      this.isLastIndex = (activeIndex >= ((this as any).steps.length - 1));
    },
  },
  mounted() {
    if (!(this as any).steps || (this as any).steps.length === 0) {
      this.goNext();
      return;
    }
    this.$cookies.set(sessionKeys.ugcIntroVideos, true, undefined);
    this.currentStep = (this as any).steps[0];
    (this as any).$refs.step0[0].src = `${(this.currentStep as any).videoUrl}`;
  },
  updated() {
    this.$cookies.set(sessionKeys.ugcIntroVideos, true, undefined);
  },
});
